// This component is responsible for the actual routing
import {createBrowserRouter, Outlet} from 'react-router';
// import HeaderOrganism from "../components/header/Header";
// import useSubscribeAccounts from "../hooks/useSubscribeAccounts";
import {filterArrayUndefined} from '@coolcolduk/util';
import {Paper} from '@mui/material';
import {Maybe, UserAccount} from '../__generated__/resolvers-types';
import AboutPage from '../external/about/AboutPage';
import FeaturePage from '../external/feature/FeaturePage';
import LandingPage from '../external/landing/LandingPage';
import PricingPage from '../external/pricing/PricingPage';
import {getAllFeatures} from '../features';
import FeatureDashboard from '../pages/featureDashboard/FeatureDashboard';
import ErrorPage from '../pages/other/ErrorPage';
import NotAuthenticatedPage from '../pages/other/NotAuthenticatedPage';
import TextOnlyMarkdownPage from '../pages/other/TextOnlyMarkdownPage';
import {getAllSettings} from '../pages/settings';
import AppLayout from '../router/AppLayout';
import BranchRoute from '../router/BranchRoute';
import {env} from '../util/env/getEnvVar';
import {privacyText} from './privacy';
import {tosText} from './tos';
import ContactPage from '../external/contact/ContactPage';

export function buildRoute(user?: Maybe<UserAccount>) {
  const featureRoutes = getAllFeatures();
  const settingsRoutes = getAllSettings();
  return createBrowserRouter([
    {
      element: (
        <AppLayout user={user}>
          <Outlet />
        </AppLayout>
      ),
      errorElement: (
        <AppLayout user={user}>
          <ErrorPage />
        </AppLayout>
      ),
      loader: () => ({}),
      children: [
        {
          path: '/tos',
          element: <TextOnlyMarkdownPage mdText={tosText} />,
        },
        {
          path: '/privacy',
          element: <TextOnlyMarkdownPage mdText={privacyText} />,
        },
        // external routes
        {
          element: <BranchRoute user={user} privateRoute={<Outlet />} publicRoute={<Outlet />} />,
          loader: () => ({}),
          children: filterArrayUndefined([
            {
              path: '/features',
              element: <FeaturePage />,
            },
            {
              path: '/about',
              element: <AboutPage />,
            },
            {
              path: '/contact',
              element: <ContactPage />,
            },
            env.subscribe
              ? {
                  path: '/pricing',
                  element: <PricingPage />,
                }
              : undefined,
          ]),
        },
        // internal routes
        {
          element: (
            <BranchRoute
              user={user}
              userUndefinedLoading
              privateRoute={<Outlet />}
              publicRoute={<NotAuthenticatedPage />}
            />
          ),
          loader: () => ({}),
          children: [
            ...featureRoutes.map((feature) => ({
              path: feature.path,
              element: (
                <Paper elevation={3} sx={{p: 2}}>
                  {feature.component(user)}
                </Paper>
              ),
            })),
            ...settingsRoutes.map((setting) => ({
              path: setting.path,
              element: (
                <Paper elevation={3} sx={{p: 2}}>
                  {setting.component(user)}
                </Paper>
              ),
            })),
          ],
        },
        // landing page
        {
          path: '/',
          loader: () => ({}),
          element: (
            <BranchRoute user={user} privateRoute={<FeatureDashboard user={user} />} publicRoute={<LandingPage />} />
          ),
        },

        {
          path: '*',
          element: <LandingPage />,
        },
      ],
    },
  ]);
}
